/**
 * محتوای استاتیک داشبورد ارائه «نگاه هوشمند | Insight».
 * این داده‌ها فقط متن و آیکون اسلایدها هستند — هیچ داده‌ی تولیدی/مشتری در آن نیست.
 * نام آیکون‌ها باید با کلیدهای ICONS در PresentationDashboard.tsx مطابقت داشته باشد.
 */

export interface PresentationSlide {
  id: string;
  type: 'cover' | 'intro' | 'goal' | 'architecture' | 'reports' | 'dashboards' | 'marketpulse' | 'screenshot' | 'changes' | 'transition' | 'roadmap' | 'closing';
  notes?: string[];
  [key: string]: any;
}

export const PRESENTATION_SLIDES: PresentationSlide[] = [
  // ۱) روی جلد
  {
    id: 'cover',
    type: 'cover',
    title: 'نگاه هوشمند',
    subtitle: 'I N S I G H T',
    version: 'رونمایی نسخه ۲ · Version 2',
    // tagline: 'از داده‌ی خام، تا تصمیم هوشمند.',
    notes: [
      'با یک جمله شروع کن: «امروز می‌خوام نشون بدم چطور داده‌های پراکنده‌ی شعبه ها رو به تصمیم تبدیل می‌کنیم.»',
      'اسم محصول و شعار رو بگو و چند ثانیه روی اسلاید بمون تا توجه جلب بشه.',
      'بگو ارائه حدود ۱۵ دقیقه‌ست و آخرش جمع‌بندی و مسیر پیش‌رو رو می‌بینیم.',
    ],
  },

  // ۲) اینسایت چیست؟ (ادغام معرفی + مشکل یکپارچگی)
  {
    id: 'intro',
    type: 'goal',
    kicker: 'اینسایت چیست؟',
    title: 'از پنل‌های پراکنده، به یک پنل یکپارچه',
    problem: {
      title: 'قبل از اینسایت',
      items: [
        'برای هر گزارش، مراجعه به یک **پنل جداگانه**',
        'باشگاه مشتریان، ارزیابی هوشمند و ... هرکدام **جدا**',
        'گزارش ها **پراکنده**',
      ],
    },
    goal: {
      title: 'با اینسایت',
      items: [
        'گزارش **همه‌ی محصولات اسمارت** در یک پنل',
        'بدون **رفت‌وآمد** بین پنل‌های مختلف',
        'علاوه بر گزارش، **تحلیل** هم ارائه می‌شود',
      ],
    },
    notes: [
      'پیام اصلی مدیریت: «الان بیشتر مشکل یکپارچگی رو حل کردیم.»',
      'بگو: «قبلاً کاربر برای باشگاه مشتریان، ارزیابی و بقیه باید به پنل‌های جدا می‌رفت؛ حالا همه رو یکجا تو اینسایت می‌بینه.»',
      'تأکید کن: «فقط گزارش نیست — تحلیل رو هم کنارش ارائه می‌دیم.»',
    ],
  },

  // ۴) چه گزارش‌هایی به مدیر می‌دهد
  {
    id: 'reports',
    type: 'reports',
    kicker: 'داشبورد چه می‌گوید',
    title: 'مدیر با یک نگاه چه می‌فهمد؟',
    desc: 'نقاط قوت و ضعف رستوران، با **گزارش‌های دقیق**.',
    reports: [
      { icon: 'Building2', title: 'مقایسه با بازار', desc: 'جایگاه نسبت به بازار' },
      { icon: 'BarChart3', title: 'رفتار خرید مشتریان', desc: 'چه می‌خرند و چگونه' },
      { icon: 'BellRing', title: 'تحلیل مشتریان', desc: 'بازگشت، ریزش و وفاداری' },
      { icon: 'MessageSquareText', title: 'تحلیل عملکرد', desc: 'فروش، شعبه و پرسنل' },
    ],
    notes: [
      'این اسلاید پر از مثاله؛ همه رو نخون — چهار-پنج تای مهم رو با مثال واقعی بگو.',
      'تأکید کن: «این‌ها فقط نمونه‌ست؛ گزارش‌های خیلی بیشتری هم داریم.»',
      'پیام کلیدی: «مدیر با یک نگاه می‌فهمه نقاط قوت و ضعف رستورانش کجاست.»',
    ],
  },

  // ۵) معرفی داشبوردها
  // {
  //   id: 'dashboards',
  //   type: 'dashboards',
  //   kicker: 'معرفی داشبوردها',
  //   title: 'یک پلتفرم، نماهای تخصصی',
  //   desc: 'هر دسته، برای یک نقش و یک تصمیم.',
  //   categories: [
  //     { icon: 'BarChart3', count: '۳', title: 'کلی و فروش', items: 'عملکرد کلی، اشتراک‌گیری و فروش' },
  //     { icon: 'TrendingUp', count: '۱', title: 'نبض بازار', items: 'مقایسه با بازار: فروش، فاکتور و سبد خرید' },
  //     { icon: 'Building2', count: '+۱', title: 'برند', items: 'نمای کلی برند و مقایسه‌ی شعب' },
  //     { icon: 'ClipboardCheck', count: '۴', title: 'ارزیابی', items: 'ارزیابی، رضایت، شکایت و پرسنل' },
  //     { icon: 'Star', count: '۵', title: 'باشگاه مشتریان', items: 'باشگاه، رفتار خرید، تحلیل' },
  //     { icon: 'Users', count: '۲', title: 'تحلیل مشتری', items: 'تحلیل و گروه‌بندی مشتریان' },
  //   ],
  //   notes: [
  //     'لازم نیست تک‌تک داشبوردها رو بخونی؛ دسته‌بندی رو بگو و یکی‌دو نمونه‌ی شاخص رو نشون بده.',
  //     'پیشنهاد: بعد از این اسلاید، اگر زمان بود یک داشبورد واقعی (مثل نبض بازار یا باشگاه) رو زنده باز کن.',
  //     'پیام کلیدی: «هر نقش سازمانی نمای مخصوص خودش رو داره؛ نه یک گزارش همه‌منظوره.»',
  //   ],
  // },

  // ★ اسلاید ویژه: نبض بازار
  {
    id: 'marketpulse',
    type: 'marketpulse',
    badge: 'داشبورد ویژه و منحصربه‌فرد',
    title: 'نبض بازار',
    subtitle: 'تنها جایی که رستوران، خودش را با بازار می‌سنجد',
    desc: 'بقیه می‌گویند چطور بودید؛ **نبض بازار** می‌گوید **نسبت به بازار کجایید**.',
    // اعداد زیر نمونه‌ی شبیه‌سازی‌شده‌اند (you = شما، market = بازار، بر حسب درصد رشد)
    // sampleNote: 'نمونه‌ی شبیه‌سازی‌شده',
    metrics: [
      { icon: 'TrendingUp', title: 'رشد فروش', you: 10, market: 25 },
      { icon: 'BarChart3', title: 'رشد تعداد فاکتور', you: 8, market: 12 },
      { icon: 'Zap', title: 'رشد قیمت', you: 18, market: 15 },
      { icon: 'Gift', title: 'رشد سبد خرید', you: 22, market: 14 },
    ],
    highlight: 'مدیر دقیقاً می‌فهمد جلوتر از بازار است یا عقب‌تر',
    notes: [
      'اینجا انرژی رو بالا ببر: «این یکی فرق می‌کنه؛ خاص‌ترین داشبورد ماست.»',
      'تفاوت کلیدی رو بگو: «بقیه می‌گن شما چطور بودید، این می‌گه نسبت به بازار کجایید.»',
      'مثال بزن: «فروشت ۱۰٪ رشد کرده؛ ولی بازار ۲۵٪ رشد کرده — یعنی در واقع عقب افتادی. این رو فقط نبض بازار بهت می‌گه.»',
      'تأکید کن این مزیت رقابتیه که تو محصولات دیگه نیست.',
    ],
  },

  // ★ نمای واقعی نبض بازار (اسکرین‌شات داشبورد)
  {
    id: 'marketpulse-shot',
    type: 'screenshot',
    kicker: 'نمای واقعی محصول',
    title: 'نبض بازار، در عمل',
    desc: 'جدول مقایسه‌ی **رشد ماهانه‌ی شعبه با بازار** — دقیقاً همان چیزی که مدیر می‌بیند.',
    image: '/screenshots/market-pulse-table.png',
    caption: 'هر ماه: عملکرد شعبه، بازار و **اختلاف** آن‌ها در فروش، فاکتور، قیمت و سبد خرید.',
    notes: [
      'اینجا از ادعا به اثبات می‌رسی: «این دیگه نمونه نیست؛ نمای واقعیِ داشبورده.»',
      'یک سطر سبز (جلوتر) و یک سطر قرمز (عقب‌تر) رو با انگشت نشون بده تا تفاوت ملموس بشه.',
      'بگو ستون «اختلاف» همون چیزیه که فقط نبض بازار می‌ده — مقایسه‌ی مستقیم با بازار.',
    ],
  },

  // ۶) تغییرات نسبت به نسخه قبل
  {
    id: 'changes',
    type: 'changes',
    kicker: 'تغییرات نسبت به نسخه قبل',
    title: 'چه چیزی بهتر شده است؟',
    // desc: 'بیش از ۱۰ داشبورد جدید و شاخص‌های عملکرد (KPI).',
    // شمارنده‌ی بالای جدول: رشد تعداد داشبوردها (نسخه قبل ← نسخه جدید)
    // stat: { beforeCount: 12, afterCount: 25, unit: 'داشبورد', suffix: '+' },
    rows: [
      // { before: '۱۲ داشبورد در ۶ بخش', after: 'بیش از ۲۵ داشبورد در ۹ بخش', icon: 'LayoutGrid' },
      { before: 'بدون شاخص عملکرد', after: '**KPIهای سنجش عملکرد** رستوران در بخش‌های مختلف', icon: 'Target' },
      { before: 'بدون مقایسه با بازار', after: 'داشبورد **«نبض بازار»**', icon: 'TrendingUp' },
      { before: 'بدون فروش و اشتراک‌گیری', after: 'داشبورد **فروش و اشتراک‌گیری**', icon: 'BarChart3' },
      { before: 'بدون نمای برند', after: 'نمای **برند و مقایسه‌ی شعب**', icon: 'Building2' },
      { before: 'تحلیل پایه‌ی مشتری', after: '**رفتار خرید و گروه‌بندی** مشتریان', icon: 'Users' },
      { before: 'بدون راهنمای تعاملی', after: '**تور راهنمای تعاملی**', icon: 'Compass' },
    ],
    notes: [
      'این تغییرات از مقایسه‌ی واقعیِ ورژن۱ با نسخه‌ی فعلی دراومده؛ روی نبض بازار و داشبوردهای مشتری بیشتر مکث کن.',
      'تأکید کن: «هیچ داشبوردی حذف نشده — فقط اضافه شده.» (۱۹۳ ← ۲۴۰ فایل)',
      'بخش‌های کاملاً جدید: نبض بازار، برند، و همین ارائه.',
    ],
  },

  // ۷) امروز ← فردا (گذار از تحلیل‌گر به مشاور هوشمند)
  {
    id: 'transition',
    type: 'transition',
    kicker: 'مسیر محصول',
    title: 'از داشبورد، به مشاور هوشمند',
    today: {
      label: 'امروز',
      title: 'داشبورد + تحلیل‌گر',
      desc: 'برای استفاده‌ی کامل، مدیر به یک تحلیل‌گر نیاز دارد.',
      items: ['تیم تحلیل ما', 'تیم نمایندگی', 'مشاوران اسمارت'],
    },
    future: {
      label: 'فردا',
      title: 'اینسایت = مشاور رستوران',
      desc: 'خودِ اینسایت مشکل را می‌گوید و نسخه می‌دهد.',
      items: ['تشخیص خودکار مشکل', 'نسخه و پیشنهاد اقدام', 'اجرای ایونت و نظرسنجی', 'بدون نیاز به مشاور'],
    },
    notes: [
      'صادق باش: «امروز برای استفاده‌ی کامل از داشبوردها، کنارِ مدیر یه تحلیل‌گر لازمه؛ تیم ما، نمایندگی و مشاوران اسمارت همین نقش رو دارن.»',
      'بعد چشم‌انداز رو بگو: «می‌خوایم به جایی برسیم که مدیر رستوران بدون مشاور خودش ازش استفاده کنه.»',
      'پیام اصلی: «خودِ اینسایت می‌گه مشکل رستوران کجاست و یک نسخه‌ی روشن دست مدیر می‌ده.»',
    ],
  },

  // ۸) چشم‌انداز
  {
    id: 'roadmap',
    type: 'roadmap',
    kicker: 'به کجا می‌رسیم',
    title: 'قابلیت‌های پیشِ رو',
    desc: 'گام‌های فنی‌ای که در نسخه‌های بعدی می‌سازیم.',
    steps: [
      { phase: 'گام بعدی', icon: 'Brain', title: 'تحلیل داده‌ها با هوش مصنوعی', desc: 'کشف خودکار نکات مهم در داده' },
      { phase: 'هسته‌ی محصول', icon: 'Target', title: 'توصیه‌گر', desc: 'هر روز پیشنهاد اقدام به مدیر' },
      { phase: 'چشم‌انداز', icon: 'Star', title: 'محصول مستقل', desc: 'فروش اینسایت به‌عنوان محصول مستقل' },
    ],
    notes: [
      'این اسلاید قلب چشم‌اندازه؛ با انرژی بگو: «امروز داده رو نشون می‌دیم، فردا خودِ سیستم اقدام رو پیشنهاد می‌ده.»',
      'روی «توصیه‌گر» بیشترین مکث رو بکن — مثال ایونت و نظرسنجی رو بگو.',
      'آخرش وصلش کن به هدف نهایی: «همه‌ی این‌ها یعنی فروش و رضایت بیشترِ مشتریان و استفاده‌ی بالاتر از محصولات اسمارت.»',
    ],
  },

  // ۸) جمع‌بندی
  {
    id: 'closing',
    type: 'closing',
    title: 'اینسایت: از داده، به اقدام',
    desc: '**باشگاه مشتریان و ارزیابی هوشمند** در یک پنل — مسیری از داشبورد به **مشاور هوشمند**.',
    takeaways: [
      'دیدِ لحظه‌ای نسبت به بازار — مزیتی که رقبا ندارند',
      'از تصمیم حسی، به تصمیم داده‌محور',
      'مسیری روشن: داشبورد ← توصیه‌گر ← مشاور مستقل',
    ],
    cta: 'اینسایت مشاور روزانه رستوران',
    notes: [
      'جمع‌بندی کوتاه: گزارش یکجا، کمک به رشد مشتری، و گذار به مشاور هوشمند.',
      'چون جمع تیم خودمونه، با یک دعوت تیمی تموم کن: «این مسیریه که با هم می‌سازیمش.»',
      'اگر دموی زنده داری، الان بهترین زمان برای نشون دادن یکی از داشبوردهای واقعیه.',
    ],
  },
];
